export default "__VITE_ASSET__CdyEbFoW__"